module.exports = __webpack_public_path__ + "static/img/guide-39.2466a99b.png";